import { render, staticRenderFns } from "./MessagesArea.vue?vue&type=template&id=4767405d&scoped=true"
import script from "./MessagesArea.vue?vue&type=script&lang=js"
export * from "./MessagesArea.vue?vue&type=script&lang=js"
import style0 from "./MessagesArea.vue?vue&type=style&index=0&id=4767405d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4767405d",
  null
  
)

export default component.exports